import React, { useState, useEffect, useRef } from "react";
import * as d3 from "d3";

const ToggleControl = ({
  offLabel = "Off",
  onLabel = "On",
  offIcon = "⭕",
  onIcon = "✅",
  initialState = false,
  onChange,
  useActiveForBothStates = false,
}) => {
  const [isActive, setIsActive] = useState(initialState);
  const svgRef = useRef(null);

  useEffect(() => {
    drawIcon();
  }, [isActive]);

  const toggleState = () => {
    const newState = !isActive;
    setIsActive(newState);
    if (onChange) {
      onChange(newState);
    }
  };

  const drawIcon = () => {
    const size = 16;
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    // Draw circle
    svg
      .append("circle")
      .attr("cx", size / 2)
      .attr("cy", size / 2)
      .attr("r", size / 2 - 1)
      .attr("fill", isActive ? "#93c5fd" : "none")
      .attr("stroke", isActive ? "#93c5fd" : "#9ca3af")
      .attr("stroke-width", 1);

    // Draw icon
    svg
      .append("text")
      .attr("x", size / 2)
      .attr("y", size / 2)
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("font-size", size * 0.7)
      .attr("fill", isActive ? "#ffffff" : "#9ca3af")
      .text(isActive ? onIcon : offIcon);
  };

  return (
    <button
      onClick={toggleState}
      className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm transition-colors duration-300 ${
        isActive
          ? "bg-blue-500/40 text-gray-200"
          : useActiveForBothStates
          ? "bg-blue-500/40 text-gray-200"
          : "bg-gray-700 text-gray-300 hover:bg-gray-600"
      }`}
    >
      <svg ref={svgRef} width="16" height="16"></svg>
      <span>{isActive ? onLabel : offLabel}</span>
    </button>
  );
};

export default ToggleControl;
